import {
  ReviewCardBackgroundImage1,
  ReviewCardBackgroundImage2,
  ReviewCardBackgroundImage3,
  ReviewCardBackgroundImage4,
  ReviewCardBackgroundImage5,
  ReviewCardBackgroundImage6,
} from '@local/assets/images'

export const getRandomThumbnail = () => {
  const randomIndex = (Math.floor(Math.random() * 6) % 6) + 1
  if (randomIndex === 1) return ReviewCardBackgroundImage1.src

  if (randomIndex === 2) return ReviewCardBackgroundImage2.src

  if (randomIndex === 3) return ReviewCardBackgroundImage3.src

  if (randomIndex === 4) return ReviewCardBackgroundImage4.src

  if (randomIndex === 5) return ReviewCardBackgroundImage5.src

  return ReviewCardBackgroundImage6.src
}
